module.exports = __webpack_public_path__ + "static/media/nike_show.c4e8daf6.jpg";